import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=066e7580&scoped=true"
import script from "./AddressInfo.vue?vue&type=script&lang=ts"
export * from "./AddressInfo.vue?vue&type=script&lang=ts"
import style0 from "./AddressInfo.vue?vue&type=style&index=0&id=066e7580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e7580",
  null
  
)

export default component.exports